import { ReactNode } from "react";
import { cn } from "../../lib/utils";

type Props = {
  children: ReactNode;
  className?: string;
};

export const TypographyH1 = ({ children, className, ...props }: Props) => {
  return (
    <h1
      className={cn(
        "scroll-m-20 text-4xl font-extrabold tracking-tight lg:text-5xl text-foreground",
        className
      )}
      {...props}
    >
      {children}
    </h1>
  );
};
